import { render, staticRenderFns } from "./Acbottommenu.vue?vue&type=template&id=738ba3f8&scoped=true"
import script from "./Acbottommenu.vue?vue&type=script&lang=js"
export * from "./Acbottommenu.vue?vue&type=script&lang=js"
import style0 from "./Acbottommenu.vue?vue&type=style&index=0&id=738ba3f8&prod&scoped=true&lang=css"
import style1 from "./Acbottommenu.vue?vue&type=style&index=1&id=738ba3f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738ba3f8",
  null
  
)

export default component.exports